import monitoringAttributes from './monitoring-event-attributes';

const triggerBrowserInteraction = (eventName, attributes) => {
  /** https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/interaction/ */
  /** https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/save/ */
  window.newrelic.interaction()
    .setAttribute('browser', attributes.browser)
    .setAttribute('browserVersion', attributes.browserVersion)
    .setAttribute('deviceId', attributes.deviceId)
    .setAttribute('deviceModel', attributes.deviceModel)
    .setAttribute('deviceOS', attributes.deviceOS)
    .setAttribute('deviceOSVersion', attributes.deviceOSVersion)
    .setAttribute('eventData', attributes.eventData)
    .setAttribute('eventName', eventName)
    .setAttribute('localIpv4', attributes.localIpv4)
    .setAttribute('merchantId', attributes.merchantId)
    .setAttribute('message', attributes.message)
    .setAttribute('orderId', attributes.orderId)
    .setAttribute('severity', attributes.severity)
    .setAttribute('storeId', attributes.storeId)
    .setAttribute('storeName', attributes.storeName)
    .setAttribute('userAccountId', attributes.accountId)
    .save();
};


const triggerPageAction = (eventName, attributes) => {
  /** https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/setcustomattribute/ */
  window.newrelic.setCustomAttribute('browser', attributes.browser);
  window.newrelic.setCustomAttribute('browserVersion', attributes.browserVersion);
  window.newrelic.setCustomAttribute('deviceId', attributes.deviceId);
  window.newrelic.setCustomAttribute('deviceModel', attributes.deviceModel, true);
  window.newrelic.setCustomAttribute('deviceOS', attributes.deviceOS);
  window.newrelic.setCustomAttribute('deviceOSVersion', attributes.deviceOSVersion);
  window.newrelic.setCustomAttribute('eventData', attributes.eventData);
  window.newrelic.setCustomAttribute('localIpv4', attributes.localIpv4);
  window.newrelic.setCustomAttribute('merchantId', attributes.merchantId);
  window.newrelic.setCustomAttribute('message', attributes.message);
  window.newrelic.setCustomAttribute('orderId', attributes.orderId);
  window.newrelic.setCustomAttribute('severity', attributes.severity);
  window.newrelic.setCustomAttribute('storeId', attributes.storeId);
  window.newrelic.setCustomAttribute('storeName', attributes.storeName);
  window.newrelic.setCustomAttribute('userAccountId', attributes.accountId, true);

  /** https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/addpageaction/  */
  window.newrelic.addPageAction(eventName);
};

const NewRelicMonitoringService = (store) => {
  const triggerNewRelicEvent = async (eventName, severity, message, data = 'No data provided') => {
    const eventParams = { eventName, severity, message, eventData: data };

    const eventAttributes = await monitoringAttributes.getAttributes(eventParams, store);

    triggerBrowserInteraction(eventName, eventAttributes);

    triggerPageAction(eventName, eventAttributes);

    monitoringAttributes.triggerDebuggerLogging('New Relic', eventName, eventAttributes);
  };

  return {
    triggerNewRelicEvent
  };
};

export default NewRelicMonitoringService;
